<app-card-actions *ngIf="!embedded" heading="Comments" (close)="close()"></app-card-actions>
<div class="chat" [class.modal]="!embedded" mat-dialog-content>
  <div class="user-panel" *ngIf="!embedded">
    <ng-container *ngIf="isLoadingUsers">
      <app-skeleton-loader *ngFor="let i of [].constructor(skeletonCount)">
      </app-skeleton-loader>
    </ng-container>

    <ng-container *ngIf="!isLoadingUsers">
      <div class="user" [class.selected]="selectedUser && selectedUser.key === user.key" 
           *ngFor="let user of mentionList; trackBy: trackUser; let i = index" 
           (click)="userSelect(user)"
           [matTooltip]="getUserTooltip(user)"
           matTooltipClass="user-tooltip"
           [matTooltipPosition]="'right'">
        <div class="avatar">
          <app-avatar [user]="user"></app-avatar>
        </div>
        <div class="info">
          <div class="name">{{user.name}}</div>
          <div class="unread-badge" *ngIf="getUnreadCount(user) > 0">{{getUnreadCount(user)}}</div>
        </div>
      </div>
    </ng-container>
  </div>

  <div class="chat-inner" [class.modal]="!embedded">
    <div class="bubbles" id="bubbles" #bubbles 
         [class.modal]="!embedded" 
         [class.full]="chatsFiltered.length > 5"
         (scroll)="handleScroll($event)">
      <div *ngIf="isLoadingMore" class="loading-more">
        <app-skeleton-loader></app-skeleton-loader>
      </div>

      <!-- Loading History Indicator for AI Agent -->
      <div *ngIf="isLoadingHistory" class="loading-history">
        <div class="loading-content">
          <mat-spinner diameter="40"></mat-spinner>
          <p>Loading chat history...</p>
        </div>
      </div>

      <div class="messages-container">
        @if (chatsFiltered.length > 0) {
          @for (item of chatsFiltered; track item.key; let i = $index) {
            <div class="bubble-row">

              <app-speech-bubble
                [chat]="item"
                [right]="item.senderName == currentUser"
                [cardLane]="getCardLane(item)"
                [embedded]="embedded"
                (deleted)="delete(i)"
                (replyClicked)="reply(i)">
              </app-speech-bubble>
            </div>
          }
        } @else {
          <div class="no-messages">
            <p>No messages yet. Start the conversation!</p>
          </div>
        }

        <!-- AI Typing Indicator -->
        @if (isAITyping) {
          <div class="bubble-row typing-indicator">
            <div class="typing-bubble">
              <div class="typing-dots">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          </div>
        }
      </div>
    </div>

    <div class="message-composer">
      <div class="left">
        <div class="inner">
          <div class="image-preview" *ngIf="selectedImage">
            <img [src]="selectedImage" alt="">
            <button class="remove-image" mat-icon-button (click)="selectedImage = ''">
              <mat-icon>close</mat-icon>
            </button>
          </div>

          @if (selectedReplyMessage) {
          <div class="reply-container">
            <div class="reply-header">
              <span>Replying to {{selectedReplyMessage.senderName}}</span>
              <button mat-icon-button (click)="selectedReplyMessage = null">
                <mat-icon>close</mat-icon>
              </button>
            </div>
            <app-speech-bubble [chat]="selectedReplyMessage" [embedded]="embedded" [reply]="true"
              (close)="selectedReplyMessage = null">
            </app-speech-bubble>
          </div>
          }
          
          <div class="editor-wrapper">
            <app-html-editor
              [(ngModel)]="message"
              [ngModelOptions]="{standalone: true}"
              [uploadFolder]="uploadFolder"
              (pauseSave)="$event ? disableSend = true : disableSend = false"
              (userMentioned)="itemSelected($event)"
              [users]="users"
              [codes]="codes">
            </app-html-editor>
          </div>

          <div class="message-actions">
            <!-- Clear History Button for AI Agent -->
            <button *ngIf="isAIAgent() && currentAISessionId"
                    mat-stroked-button
                    color="warn"
                    (click)="clearAIHistory()"
                    matTooltip="Clear chat history and start new conversation"
                    class="clear-history-btn">
              <mat-icon>delete_sweep</mat-icon>
              Clear History
            </button>

            <div class="spacer"></div>
            <button mat-raised-button 
              color="primary" 
              [disabled]="disableSend || (!message && !selectedImage)" 
              (click)="send()">
              Send
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>